<template>
  <div id="app">
    <div v-if="is_no_structure">
      <v-app>
        <router-view></router-view>
      </v-app>
    </div>
    <div v-if="!is_no_structure">
      <v-app>
        <Login v-model="open_login_dialog" />
        <AppBar v-on:openDrawerClicked="drawer = !drawer" />
        <Drawer v-model="drawer" />
        <v-main :style="main_bg_style">
          <v-container class="pa-0 pa-sm-3 pa-xl-6" fluid>
            <div class="delegated_info mb-3" v-if="isUseDelegated">
              <div class="delegated_info_title">
                คุณกำลังใช้งานผ่านระบบสวมสิทธิ์ผู้สมัครสำหรับเจ้าหน้าที่
                <v-btn class="ml-5" color="error" @click="$store.dispatch('auth/logoutDelegatedUser')">ออกจากการสวมสิทธิ์</v-btn>
              </div>
              <div>ชื่อเจ้าหน้าที่ : {{ delegated_name }}</div>
              <div>ชื่อผู้สมัคร : {{ delegated_student_name }}</div>
            </div>
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </v-container>
        </v-main>
        <Footer />
        <v-btn class="to-top" fab dark color="primary" v-on:click="toTop()">
          <v-icon dark> mdi-arrow-collapse-up </v-icon>
        </v-btn>
        <DevEnv />
      </v-app>
    </div>
  </div>
</template>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.full-height {
  height: 100%;
}

.to-top {
  position: fixed;
  right: 50px;
  bottom: 30px;
}

.delegated_info {
  background-color: yellowgreen;
  width: 100%;
  padding: 10px;
  .delegated_info_title {
    font-size: 20px;
  }
}
</style>

<script>
import AppBar from "@/components/structures/AppBar";
import Footer from "@/components/structures/Footer";
import Drawer from "@/components/structures/Drawer";
import Login from "@/components/structures/Login";
import DevEnv from "@/components/structures/DevEnv";
import goTo from "vuetify/es5/services/goto";
import { createHelpers } from "vuex-map-fields";
import { no_structure } from "@/router/acl";

const { mapFields: paramsFields } = createHelpers({
  getterType: "params/getField",
  mutationType: "params/updateField",
});

export default {
  name: "WebApp",
  props: {
    source: String,
  },
  components: {
    AppBar,
    Footer,
    Drawer,
    Login,
    DevEnv,
  },
  data: () => ({
    drawer: null,
    login_dialog: null,
  }),
  computed: {
    ...paramsFields({
      open_login_dialog: "open_login_dialog",
    }),
    is_no_structure() {
      return no_structure.includes(this.$route.name);
    },
    loggedIn() {
      return this.$store.state.auth.login_status;
    },
    isUseDelegated() {
      if (
        this.$store.state.auth.user &&
        this.$store.state.auth.user.admission.status &&
        this.$store.state.auth.user.delegated_officer.status
      ) {
        return true;
      }
      return false;
    },
    delegated_student_name() {
      if (
        this.$store.state.auth.user &&
        this.$store.state.auth.user.admission.status
      ) {
        return (
          this.$store.state.auth.user.admission.STUDENT_FNAME_TH +
          " " +
          this.$store.state.auth.user.admission.STUDENT_LNAME_TH
        );
      }
      return "";
    },
    delegated_name() {
      if (
        this.$store.state.auth.user &&
        this.$store.state.auth.user.delegated_officer.status
      ) {
        return this.$store.state.auth.user.delegated_officer.t_name;
      }
      return "";
    },
    main_bg_style() {
      const main_bg_undergradute = "background-color: #c98b7b;";
      const main_bg_master = "background-color: #73bba9;";
      const main_bg_phd = "background-color: #8fbb73;";
      const main_bg = "background-color: #d7d7d7;";

      if (this.$route.name === "master_explore") return main_bg_master;
      else if (this.$route.name === "phd_explore") return main_bg_phd;
      else if (
        this.$route.name === "undergraduate_explore" ||
        this.$route.name === "slash_default" ||
        this.$route.name === "default"
      )
        return main_bg_undergradute;
      return main_bg;
    },
  },
  methods: {
    toTop() {
      goTo(0);
    },
  },
};
</script>
